import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { AppApi } from "./api/apis";
import { commonSlice } from "./commonSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import encryptTransform from "./transform";
import { notificationSlice } from "./notificationSlice";

const reducers = combineReducers({
  [AppApi.reducerPath]: AppApi.reducer,
  commonReducer: commonSlice.reducer,
  notificationReducer: notificationSlice.reducer,
});

const persistConfig = {
  key: "root",
  storage,
  blacklist: [AppApi.reducerPath, "notificationReducer"],
  transforms: [encryptTransform],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(AppApi.middleware),
});

setupListeners(store.dispatch);
